import { useEffect, useState } from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function KryptoGo() {
  const [articleContent, setArticleContent] = useState([]);
  const [sliderContent, setSliderContent] = useState([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);

  useEffect(() => {
    let pageType = 0;
    let id = 13;
    fetch(`/api/homepage/pageResource/${pageType}/${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const pageData = data.data.article[0].article[0];
        setArticleContent([pageData]);
        const sliderData = data.data.slider;
        setSliderContent(sliderData);
      })
      .catch((error) => console.error("Error fetching article content:", error));
  }, []);

  return (
    <>
      <Navbar />
      <main className="pb-[166px]">
        {articleContent.map((item, index) => (
          <section className="h-[700px] w-[975px] m-auto mt-[64px] mb-[-260px]" key={index}>
            <div className="text-center mb-[44px]">
              <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">{item.title}</h2>
              <h3 className="text-[#FF6B2B] font-normal text-xl">Introduction</h3>
            </div>
            <div
              className="text-start text-[#373737] font-normal text-base leading-loose mb-[40px] md-l:mx-10"
              dangerouslySetInnerHTML={{ __html: item.content }}
            ></div>
            <img
              src={item.thumbnailUrl}
              alt=""
              className="m-auto h-[372px] object-contain border-8 border-white shadow-xl relative"
            />
          </section>
        ))}
        <section className="bg-yellow md-l:pt-[1000px] md-l:mb-[550px]">
          <div className="flex pt-[330px] h-[630px] md-l:flex-col-reverse">
            <div>
              <img
                src={sliderContent[selectedCardIndex]?.url}
                alt=""
                className="object-cover w-[1060px] h-[630px]"
              />
            </div>
            <div className="bg-white h-[630px] shadow-lg py-[30px] px-[110px]">
              <div className="text-center">
                <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[9px]">活動照片</h2>
                <h3 className="text-[#FF6B2B] font-normal text-xl mb-[28px]">Recorded photo</h3>
              </div>
              <div className="w-[640px] h-[450px] m-auto overflow-y-scroll scrollbar">
                {sliderContent.map((item, index) => (
                  <div
                    className="flex h-[150px] justify-start gap-4 p-4 border-b border-[#DBDBDB] hover:bg-[#F6F6F6]"
                    key={index}
                    onClick={() => setSelectedCardIndex(index)}
                  >
                    <img src={item.url} alt="" className="h-[120px] w-[180px] object-cover" />
                    <div>
                      <h3 className="text-[#A93230] font-normal text-xl mb-2">{item.title}</h3>
                      <p className="text-[#696969] font-normal text-l">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default KryptoGo;
